/**
*  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/


import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LoginResponse, OauthResponse } from './model/loginresponse';
import { DomainResponse } from './model/domainresponse';
import { PasswordResetResponse } from './model/passwordresetresponse';
import { CustomizationEnabledResponse } from './model/customizationenabledresponse';
import { CommonConstants } from '../common/constants/common-constants';


@Injectable()
export class LoginService {

    constructor(public http: HttpClient) {
    }

    // Get call to fetch list of available login domains
    // To be called in constructor of the component
    public getDomains() {
        return this.http.get<DomainResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/domains');
    }


    // Get call to fetch SSPR link
    // To be called in constructor of the component
    public getPasswordResetLink() {
        return this.http.get<PasswordResetResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/ssprlink');
    }

    // Get call to fetch eup customization is enabled or not
    public isCustomizeEnabled() {
        return this.http.get<CustomizationEnabledResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customizeEnabled');
    }

    // Post call for authentication
    public authenticate(username: string, password: String, ldapSourceId: Number) {
        return this.http
            .post<LoginResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/auth/login', {
                'username': username,
                'password': password,
                'ldapSourceId': ldapSourceId
            });
    }

    // Function to check if user has a non expired token
    public isLoggedIn(): boolean {
        const token = localStorage.getItem('token');
        const refreshToken = localStorage.getItem('refreshToken');
        if (token != null && refreshToken != null) {
            const decodedToken = this.decodeJWT(token);
            const tokenExpiry = decodedToken.exp;
            const currentTime = Math.trunc(new Date().getTime() / 1000);
            if (tokenExpiry < currentTime) {
                return false;   // Token has expired
            } else {
                return true;    // Token is vaild
            }
        }
        return false;   // No Token is present
    }

    // Function to extract payload of token
    public decodeJWT(token) {
        let base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }


    // Function to Fetch the Auth URL and Provider Id, Name 
    public oauthUserDetails(userName: string, redirectLandingUri: string){
        let params = new HttpParams()
        .set('userName', userName)
        .set('redirectLandingUri', redirectLandingUri);
        return this.http.post<OauthResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/auth/oauthinfo', null, {params});
    }


    // oauthLogin
    public oauthLogin(userName: string, authCode:string, redirectLandingUri: string){
        let params = new HttpParams()
        .set('state', userName)
        .set('authCode', authCode)
        .set('redirectLandingUri', redirectLandingUri);
        return this.http.post<LoginResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/auth/oauthLogin', null, {params});
    }
}
